import script from "./OrderDetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderDetailsModal.vue?vue&type=script&setup=true&lang=js"

import "./OrderDetailsModal.vue?vue&type=style&index=0&id=8ea55600&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ea55600"]])

export default __exports__